import React from "react";
import { Spinner } from "reactstrap";

export default function LoadingFullScreen () {
  return <div style={{ height: '100vh', width: '100vw' }}
              className={'d-flex flex-row justify-content-center align-items-center'}>
    <Spinner color={'success'}/>
  </div>
}